/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getBooleanDecoder,
  getBooleanEncoder,
  getStructDecoder,
  getStructEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

export type AuthorizationPolicies = {
  defaultDeny: boolean;
  explicitPermissionsRequired: boolean;
};

export type AuthorizationPoliciesArgs = AuthorizationPolicies;

export function getAuthorizationPoliciesEncoder(): FixedSizeEncoder<AuthorizationPoliciesArgs> {
  return getStructEncoder([
    ["defaultDeny", getBooleanEncoder()],
    ["explicitPermissionsRequired", getBooleanEncoder()],
  ]);
}

export function getAuthorizationPoliciesDecoder(): FixedSizeDecoder<AuthorizationPolicies> {
  return getStructDecoder([
    ["defaultDeny", getBooleanDecoder()],
    ["explicitPermissionsRequired", getBooleanDecoder()],
  ]);
}

export function getAuthorizationPoliciesCodec(): FixedSizeCodec<
  AuthorizationPoliciesArgs,
  AuthorizationPolicies
> {
  return combineCodec(
    getAuthorizationPoliciesEncoder(),
    getAuthorizationPoliciesDecoder(),
  );
}
